import { ITEMS } from '@moba/shared';
import { assetUrl } from './assets.ts';

/**
 * Sprites de los objetos (`assets/items/<id>.png`, recortados de Super Smash
 * Flash 2; ver assets/LICENSES.md). La URL lleva la huella del archivo
 * (`assetUrl`), como los modelos, para que un sprite nuevo nunca salga de caché.
 */
export function itemIconUrl(id: string): string {
  if (!ITEMS[id]) return '';
  return assetUrl(`/items/${id}.${SVG_ICONS.has(id) ? 'svg' : 'png'}`);
}

/** Ilustraciones propias (SVG vectorial), no sprites de SSF2: las botas de cada rol. */
const SVG_ICONS = new Set(['boots', 'fighter-boots', 'tank-boots', 'marksman-boots', 'assassin-boots']);
